import PersonalSettingsDialog from './components/PersonalSettingsDialog';
export default PersonalSettingsDialog;
